import { faEthereum } from '@fortawesome/free-brands-svg-icons';
import { faWallet } from '@fortawesome/pro-solid-svg-icons';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Cryptocurrency } from '#src/__generated__/globalTypes.ts';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { SolanaIcon } from '#src/atoms/icons/SolanaIcon.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelS, LabelXS } from '#src/atoms/typography/index.tsx';
import { Dots } from '#src/atoms/ui/Dots/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useWalletDrawerContext } from '#src/contexts/walletDrawer/index.tsx';
import { useCryptoBalance } from '#src/hooks/useCryptoBalance.ts';
import { useFiatBalance } from '#src/hooks/wallets/useFiatBalance.ts';

const StyledButtonBase = styled(ButtonBase)`
  padding: 0 var(--half-unit);
  flex-shrink: 0;
`;

export const CompactBalances = () => {
  const { toggleDrawer } = useWalletDrawerContext();
  const {
    walletPreferences: { showCryptoWallet, showFiatWallet },
  } = useCurrentUserContext();
  const { fiatCurrency, availableBalance } = useFiatBalance({
    notation: 'compact',
    compactDisplay: 'short',
  });

  const { hideBalance, cryptocurrency, roundedCryptoValue } =
    useCryptoBalance();

  const displayBoth = showCryptoWallet && showFiatWallet && !hideBalance;

  const Text = displayBoth ? LabelXS : LabelS;

  return (
    <StyledButtonBase onClick={toggleDrawer}>
      <Vertical gap={0.5} center>
        <FontAwesomeIcon icon={faWallet} size="sm" />
        <Vertical gap={0} center>
          {hideBalance ? (
            <LabelS bold>
              <Dots count={3} size="small" />
            </LabelS>
          ) : (
            <LabelS bold>
              {!!showFiatWallet && (
                <Text bold>
                  <FormattedNumber
                    value={availableBalance}
                    currency={fiatCurrency}
                    notation="compact"
                    compactDisplay="short"
                    style="currency"
                  />
                </Text>
              )}
              {!!showCryptoWallet && (
                <Text
                  bold
                  color={displayBoth ? 'var(--c-nd-600)' : 'var(--c-white)'}
                >
                  <FormattedNumber
                    value={roundedCryptoValue}
                    currency={cryptocurrency}
                    notation="compact"
                    compactDisplay="short"
                  />{' '}
                  {cryptocurrency === Cryptocurrency.LAMPORT ? (
                    <SolanaIcon width={8} height={8} />
                  ) : (
                    <FontAwesomeIcon icon={faEthereum} size="sm" />
                  )}
                </Text>
              )}
            </LabelS>
          )}
        </Vertical>
      </Vertical>
    </StyledButtonBase>
  );
};
